import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { StoreItemComponent } from '@features/stores-overview/components/store-item/store-item.component';
import { StoresOverviewComponent } from '@features/stores-overview/components/stores-overview/stores-overview.component';
import { StoresComponent } from '@features/stores-overview/components/stores/stores.component';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';
import { SharedModule } from '@shared/shared.module';
import { ToHtmlPopupPropPipe } from './pipes/to-html-popup-prop.pipe';
import { ByRegionPipe } from './pipes/by-region.pipe';
import { ActiveRegionPipe } from './pipes/active-region.pipe';

@NgModule({
    imports: [CommonModule, SharedModule, RouterModule, FormElementsModule, StoresOverviewComponent,
    StoresComponent,
    StoreItemComponent,
    ToHtmlPopupPropPipe,
    ByRegionPipe,
    ActiveRegionPipe],
    exports: [StoresOverviewComponent, StoresComponent, StoreItemComponent]
})
export class StoresOverviewModule {}
